import React from "react";
import { Box, Typography } from "@mui/material";
import { NJIM } from "../../theme/njimTheme";

interface CodSectionHeaderProps {
  title: string;
  helper?: string;
  action?: React.ReactNode;
}

const CodSectionHeader: React.FC<CodSectionHeaderProps> = ({
  title,
  helper,
  action,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: { xs: "flex-start", sm: "center" },
      justifyContent: "space-between",
      gap: 2,
      flexWrap: "wrap",
      mb: 2,
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: { xs: 16, sm: 18 },
          fontWeight: 600,
          color: NJIM.ink,
          lineHeight: 1.3,
        }}
      >
        {title}
      </Typography>
      {helper ? (
        <Typography sx={{ mt: 0.5, fontSize: 13, color: NJIM.textSecondary, lineHeight: 1.45 }}>
          {helper}
        </Typography>
      ) : null}
    </Box>
    {action ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          marginInlineStart: "auto",
        }}
      >
        {action}
      </Box>
    ) : null}
  </Box>
);

export default CodSectionHeader;
